<h2 mat-dialog-title>SELECCIONAR TUTOR</h2>

<div mat-dialog-content class="content">
  <p class="hint">
    SE ENCONTRARON VARIOS TUTORES PARA: <b class="break">{{ data.email }}</b>
  </p>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>TUTOR</mat-label>

    <mat-select [formControl]="ctrl">
      <mat-option
        *ngFor="let opt of data.options; trackBy: trackById"
        [value]="opt.idUsuario">
        <div class="opt-line">
          <span class="opt-name">{{ opt.nombreCompleto }}</span>
        </div>
      </mat-option>
    </mat-select>

    <mat-icon matSuffix>supervisor_account</mat-icon>
  </mat-form-field>

  <div class="err" *ngIf="ctrl.touched && ctrl.invalid">
    <small>DEBES SELECCIONAR UN TUTOR.</small>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">CANCELAR</button>
  <button mat-raised-button color="primary" type="button" (click)="aceptar()">
    CONTINUAR
  </button>
</div>
